import React, { useContext } from "react";
import styles from "./FileCard.module.scss";
import PathContext from "../../context/path";
const FileCard = (props) => {
  const { label, title, text, img, color } = props;
  const path = useContext(PathContext);
  let textElement = [];
  if (text !== undefined && text.length > 0) {
    text.forEach((element, index) => {
      textElement.push(<p key={`text-${index}`}>{element}</p>);
    });
  }
  let wrapClass = `${styles.wrap}`;
  if (color !== undefined && styles[`wrap_${color}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_${color}`]}`;
  }
  return (
    <>
      <div className={wrapClass}>
        <div className={styles.label}>{label}</div>
        <div className={styles.info}>
          <div className={styles.title}>{title}</div>
          <div className={styles.text}>
            {textElement}
          </div>
        </div>
        <div className={styles.img}>
         
        <picture>
            <source media="(min-width: 1921px)" srcSet={`${path}/img/${img}@2x.webp`} />
            <source media="screen and (max-width: 767px)" srcSet={`${path}/img/${img}-mobile.webp, ${path}/img/${img}-mobile@2x.webp 2x`} />
            <img src={`${path}/img/${img}.webp`} srcSet={`${path}/img/${img}@2x.webp 2x`} alt="" />
          </picture>
        </div>
      </div>
    </>
  );

}

export default FileCard;
